export default "__VITE_ASSET__DfjgA3uU__"